export { Book3D } from './Book3D';
export type { Book3DProps } from './Book3D.types';
